// This file is auto-generated by scripts/collectTwMerge.ts
// Do not edit manually - run 'bun run collect:twmerge' to regenerate

export const colors = [
  "neutral-0",
  "neutral-25",
  "neutral-50",
  "neutral-100",
  "neutral-200",
  "neutral-300",
  "neutral-400",
  "neutral-500",
  "neutral-600",
  "neutral-700",
  "neutral-800",
  "neutral-900",
  "orange-50",
  "orange-100",
  "orange-200",
  "orange-300",
  "orange-400",
  "orange-500",
  "orange-600",
  "orange-700",
  "orange-800",
  "orange-900",
  "green-300",
  "green-400",
  "green-500",
  "green-600",
  "green-700",
  "red-300",
  "red-400",
  "red-500",
  "red-600",
  "red-700",
  "yellow-300",
  "yellow-400",
  "yellow-500",
  "yellow-600",
  "yellow-700",
  "blue-1-300",
  "blue-1-400",
  "blue-1-500",
  "blue-1-600",
  "blue-1-700",
  "blue-2-300",
  "blue-2-400",
  "blue-2-500",
  "blue-2-600",
  "purple-50",
  "purple-100",
  "purple-200",
  "purple-300",
  "purple-400",
  "purple-500",
  "purple-600",
  "purple-700",
  "purple-800",
  "purple-900",
  "alpha-white",
  "alpha-black",
] as const

export const spacing = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "6",
  "8",
  "10",
  "12",
  "14",
  "16",
  "18",
  "20",
  "24",
  "32",
  "40",
  "p25",
  "p5",
] as const
